<template>
    <div name="notice" class="slider-container">
        <!-- 자동 롤링 -->
        <img class="left-arrow" src="../../assets/arrow_left.png" @click="prevSlide"/>
        <img class="right-arrow" src="../../assets/arrow_right.png" @click="nextSlide"/>
        <div 
            class="slider"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
            >

            <!-- <div class="current-page">{{ (currentIndex % 2) === 0 ? '1' : '2' }} / {{images.length}}</div> -->
            <div class="slider-wrapper" :style="{ transform: `translateX(-${(currentIndex + 1) * 100}%)`, transition: isAnimating ? 'transform 0.5s ease-in-out' : 'none' }" >
               
                <div @click="open(contents[contents.length - 1].url)">
                    <span class="tag-text">{{ contents[contents.length - 1].tag }}</span>
                    <span class="title-text">{{ contents[contents.length - 1].title }}</span>
                </div>
                
                <div v-for="(content, index) in contents" :key="index" @click="open(content.url)">
                    <span class="tag-text">{{ content.tag }}</span>
                    <span class="title-text">{{ content.title }}</span>
                    
                </div>
                <div @click="open(contents[0].url)">
                    <span class="tag-text">{{ contents[0].tag }}</span>
                    <span class="title-text">{{ contents[0].title }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'notice',
    data: function()
    {
        return {
            contents: [
                {
                    tag: '[공지]', title: '연말정산용 의료기기 명세서 안내', url: 'https://docs.channel.io/solcon/ko/articles/%EC%97%B0%EB%A7%90%EC%A0%95%EC%82%B0%EC%9A%A9-%EC%9D%98%EB%A3%8C%EA%B8%B0%EA%B8%B0-%EC%A7%80%EC%B6%9C-%EB%AA%85%EC%84%B8%EC%84%9C-%EC%95%88%EB%82%B4--4c75c4eb'
                },
                {
                    tag: '[공지]', title: '세법상 ‘장애인 증명서’ 발급 안내', url: 'https://docs.channel.io/solcon/ko/articles/-%EC%9E%A5%EC%95%A0%EC%9D%B8-%EC%A6%9D%EB%AA%85%EC%84%9C-%EB%B0%9C%EA%B8%89-%EC%95%88%EB%82%B4-606090de'
                },
                {
                    tag: '[이벤트]', title: '저혈당 대비 응급카드 신청', url: 'https://docs.channel.io/solcon/ko/articles/-1%ED%98%95-%EB%8B%B9%EB%87%A8-%EC%9D%91%EA%B8%89-%EC%B9%B4%EB%93%9C-%EC%95%88%EB%82%B4--b3dd6c39'
                },
                {
                    tag: '[이벤트]', title: '공항 의료기기 안내카드 신청', url: 'https://docs.channel.io/solcon/ko/articles/-%EA%B3%B5%ED%95%AD-%EA%B2%80%EC%83%89%EB%8C%80-%ED%86%B5%EA%B3%BC-%EC%95%88%EB%82%B4%EC%B9%B4%EB%93%9C-%EC%95%88%EB%82%B4-5a973648'
                },
                // {
                //     tag: '[공지]', title: '저혈당 치료제 ‘바크시미’ 도입 예정 안내', url: 'https://docs.channel.io/solcon/ko/articles/%EB%B0%94%ED%81%AC%EC%8B%9C%EB%AF%B8%EA%B8%80%EB%A3%A8%EC%B9%B4%EA%B3%A4-%EC%B2%98%EB%B0%A9-%EC%95%88%EB%82%B4-acfd88ee'
                // },
            ],
            currentIndex: 0,
            isAnimating: true,
            interval: null,
            touchStartX: 0,
            touchEndX: 0,
            curIndex: 1
        }
    },
    mounted: function()
    {
        if(this.contents.length > 1)
        {
            this.startAutoSlide();
        }
    
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        open: function(url)
        {
            if(url !== '')
            {
                this.$emit('open', url)
            }            
        },
        openUrl: function()
        {
        if (window.ChannelIO) {
            window.ChannelIO('showMessenger');
        } else {
            console.warn('ChannelIO가 아직 초기화되지 않았어요!');
        }
        },
        // 자동 슬라이드 시작
        startAutoSlide() {
            if (this.interval) clearInterval(this.interval);
                this.interval = setInterval(() => {
                this.nextSlide();
            }, 5000); // 3초마다 변경
        },
        // 다음 슬라이드
        nextSlide() {
            if (this.currentIndex >= this.contents.length) {
                this.isAnimating = false;
                this.currentIndex = 0;
                setTimeout(() => {
                this.isAnimating = true;
                this.currentIndex++;
                }, 50);
            } else {
                this.currentIndex++;
            }
            this.startAutoSlide(); // 슬라이드 이동 시 타이머 리셋
        },
        // 이전 슬라이드
        prevSlide() {
            if (this.currentIndex <= 0) {
                this.isAnimating = false;
                this.currentIndex = this.contents.length;
                setTimeout(() => {
                this.isAnimating = true;
                this.currentIndex--;
                }, 50);
            } else {
                this.currentIndex--;
            }
            this.startAutoSlide(); // 슬라이드 이동 시 타이머 리셋
        },
        // 터치 시작 감지
        handleTouchStart(event) {
            if(this.contents.length > 1)
            {
                this.touchStartX = event.touches[0].clientX;
                clearInterval(this.interval); // 사용자가 터치하면 자동 롤링 정지
            }

        },
        // 터치 이동 감지
        handleTouchMove(event) {
            if(this.contents.length > 1)
            {
                this.touchEndX = event.touches[0].clientX;
            }

        },
        // 터치 끝 감지 및 방향에 따라 이동
        handleTouchEnd() {
            if(this.contents.length > 1)
            {
                const swipeDistance = this.touchStartX - this.touchEndX;

                if (swipeDistance > 50) {
                    this.nextSlide(); // 오른쪽에서 왼쪽으로 스와이프 → 다음 슬라이드
                } else if (swipeDistance < -50) {
                    this.prevSlide(); // 왼쪽에서 오른쪽으로 스와이프 → 이전 슬라이드
                }
                this.startAutoSlide(); // 터치 동작 후 자동 롤링 다시 시작
            }

        }
    }
}
</script>

<style scoped>
    .slider-container {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 100%;
        overflow: hidden;
        height: 44px;
        background: var(--Gray-00, #FFF);
        padding: 0 16px;
        box-sizing: border-box;
    }
    .slider-wrapper {
        display: flex;
        width: 100%;
        height: 100%;
        transition: transform 0.5s ease-in-out;
        will-change: transform;
    }
    .slider-wrapper div {
        width: 100%;
        flex-shrink: 0;
        object-fit: cover;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .slider {
        width: calc(100% - 52px);
        overflow: hidden;
        position: relative;
    }
    .tag-text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
    }
    .title-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
    }
    .left-arrow {
        position: absolute;
        left: 10px;
        cursor: pointer;
    }
    .right-arrow {
        position: absolute;
        right: 10px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/Notice.vue